export enum ResourceType {
  Learning = 'learning',
  Practice = 'practice',
  AdditionalResource = 'additional_resource',
}
